(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-interactions"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.PawHabit) return;
  const money = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100);
  const runtime = () => document.querySelector('.ph-runtime');
  const root = () => runtime()?.dataset.pawRoot || '/';
  const sections = () => [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
  async function request(path, data) {
    const res = await fetch(root()+path, {method:data?'POST':'GET',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',...(data?{body:JSON.stringify(data)}:{})});
    const body = await res.json();
    if(!res.ok || body.status >= 400) throw new Error(body.description || body.message || runtime()?.dataset.pawError);
    return body;
  }
  async function updateCart(items, code, source, formData) {
    if(window.PawHabit.busy) return false;
    window.PawHabit.busy = true;
    let eventPromise, CartEvent;
    try {
      const mod = await import('@shopify/events'); CartEvent = mod.CartLinesUpdateEvent;
      eventPromise = CartEvent.createPromise();
      source.dispatchEvent(new CartEvent({action:items.length?'add':'update',context:'product',lines:items.map(i=>({merchandiseId:String(i.id),quantity:i.quantity})),promise:eventPromise.promise}));
      let response;
      if(formData){
        formData.set('sections',sections().join(','));formData.set('sections_url',location.pathname);
        const res=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:formData});
        response=await res.json();if(!res.ok||response.status>=400)throw new Error(response.description||response.message||runtime()?.dataset.pawError);
      }else response=items.length?await request('cart/add.js',{items,sections:sections(),sections_url:location.pathname}):null;
      let cart = await request('cart.js');
      let discountWarning = false;
      if(code) {
        const existing = (cart.discount_codes || []).filter(d=>d.applicable).map(d=>d.code);
        const codes = [...new Set([...existing,code])].join(',');
        try {
          response = await request('cart/update.js',{discount:codes,sections:sections(),sections_url:location.pathname});
          cart = response;
          discountWarning = !(cart.discount_codes || []).some(d=>d.code.toLowerCase()===code.toLowerCase() && d.applicable);
        } catch { discountWarning = true; }
      }
      if(!response?.sections) response = await request('cart/update.js',{sections:sections(),sections_url:location.pathname});
      eventPromise.resolve({cart:CartEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:response.sections,source:'paw-habit',sourceId:source.id,itemCount:items.reduce((s,i)=>s+i.quantity,0),didError:false}});
      if(items.length && !document.querySelector('#cart-drawer')) location.assign(runtime()?.dataset.pawCart || root()+'cart');
      if(discountWarning) {
        const error=source.querySelector('[data-error]');
        if(error){error.hidden=false;error.textContent=runtime()?.dataset.discountWarning;}
      }
      return true;
    } catch(error) {
      eventPromise?.reject(error);
      throw error;
    } finally { window.PawHabit.busy=false; }
  }
  const saleEnded=()=>{const end=Date.parse(runtime()?.dataset.saleEndsAt||'');return Number.isFinite(end)&&Date.now()>=end;};
  window.PawHabit={money,updateCart,busy:false,saleEnded};
  function syncSaleWindow(){document.documentElement.classList.toggle('ph-promotion-ended',saleEnded());}
  syncSaleWindow();
  const saleDeadline=Date.parse(runtime()?.dataset.saleEndsAt||'');
  if(Number.isFinite(saleDeadline)&&saleDeadline>Date.now())setTimeout(syncSaleWindow,Math.min(saleDeadline-Date.now()+10,2147483647));
  document.addEventListener('visibilitychange',syncSaleWindow);
  document.addEventListener('shopify:section:load',syncSaleWindow);
  class PawOfferCountdown extends HTMLElement {
    connectedCallback(){
      clearInterval(this.timer);
      this.end=Date.parse(this.dataset.endsAt);
      this.tick=()=>{
        const left=this.end-Date.now();
        if(!Number.isFinite(left)||left<=0){this.hidden=true;clearInterval(this.timer);syncSaleWindow();return;}
        const seconds=Math.ceil(left/1000),days=Math.floor(seconds/86400),hours=Math.floor(seconds%86400/3600),mins=Math.floor(seconds%3600/60),secs=seconds%60;
        const text=this.querySelector('[data-countdown-value]');
        if(text)text.textContent=(days?days+this.dataset.day+' · ':'')+hours+this.dataset.hour+' · '+String(mins).padStart(2,'0')+this.dataset.minute+' · '+String(secs).padStart(2,'0')+this.dataset.second;
        const tiles=this.querySelector('[data-countdown-tiles]');
        if(tiles){
          for(const [unit,value] of Object.entries({days,hours,minutes:mins,seconds:secs})){
            const node=tiles.querySelector('[data-clock-'+unit+']');
            const number=String(value).padStart(2,'0');
            if(node&&node.textContent!==number)node.textContent=number;
          }
          tiles.hidden=false;
        }
      };
      this.tick();if(this.end>Date.now())this.timer=setInterval(this.tick,1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  }
  if(!customElements.get('paw-offer-countdown'))customElements.define('paw-offer-countdown',PawOfferCountdown);

  const motionPreference=matchMedia('(prefers-reduced-motion:reduce)');
  const motionSeen=new WeakSet();
  let motionObserver;
  function initMotion(scope=document){
    const enabled=runtime()?.dataset.pawMotion!=='false'&&!motionPreference.matches;
    document.documentElement.classList.toggle('ph-motion',enabled);
    if(!enabled){motionObserver?.disconnect();document.getAnimations().filter(a=>a.id==='paw-reveal').forEach(a=>a.cancel());return;}
    if(!('IntersectionObserver' in window))return;
    motionObserver??=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      const el=entry.target;motionObserver.unobserve(el);
      const animation=el.animate([{opacity:0.35,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:620,easing:'cubic-bezier(.2,.7,.2,1)'});animation.id='paw-reveal';
    }),{threshold:0.12});
    scope.querySelectorAll('.ph-home-hero__copy,.ph-home-hero__visual,.pet-essentials__header,.pet-essential,.ph-home-set__photos,.ph-home-set__copy,.ph-catalog__intro,.ph-catalog-card,.ph-problem-grid>*,.ph-review-card,.ph-department,.ph-values article').forEach(el=>{if(!motionSeen.has(el)){motionSeen.add(el);motionObserver.observe(el);}});
  }
  initMotion();
  document.addEventListener('shopify:section:load',()=>initMotion());
  motionPreference.addEventListener('change',()=>initMotion());

  class PawProduct extends HTMLElement {
    connectedCallback(){
      if(this.dataset.ready) return; this.dataset.ready='true';this.saleWasActive=!saleEnded();
      this.variants=JSON.parse(this.querySelector('[data-paw-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-paw-labels]').textContent);this.form=this.querySelector('.ph-form');
      this.setupCompositeOptions();
      const offer=new URL(location.href).searchParams.get('offer');if(offer==='pair'||offer==='duo'){const option=this.querySelector('[name="paw_offer"][value="'+offer+'"]');if(option)option.checked=true;}
      this.addEventListener('change',e=>{
        if(e.target.matches('[data-composite-axis]')){
          const size=this.querySelector('[data-composite-axis="size"]:checked')?.value,pack=this.querySelector('[data-composite-axis="pack"]:checked')?.value;
          const input=[...this.querySelectorAll('[data-product-option="1"]')].find(x=>{const parts=this.sockParts(x.value);return parts&&parts[1]===size&&parts[2]===pack;});
          if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}return;
        }
        if(e.target.matches('[data-product-option]')){
          const selectors=[...this.querySelectorAll('[data-product-option]')],values=[...this.querySelectorAll('[data-product-option]:checked')].map(x=>x.value),changed=Number(e.target.dataset.productOption);
          const matching=this.variants.filter(v=>v.options[changed]===values[changed]);
          const score=v=>v.options.reduce((n,value,i)=>n+(value===values[i]?2:0),v.available?1:0);
          const next=this.variants.find(v=>v.options.every((value,i)=>value===values[i]))||matching.sort((a,b)=>score(b)-score(a))[0];
          if(next){this.form.elements.id.value=next.id;selectors.forEach(el=>el.checked=el.value===next.options[Number(el.dataset.productOption)]);this.syncVariantImage(next);}
        }
        if(e.target.matches('[data-pet-photo]'))this.previewPhoto(e.target);
        this.update();
      });
      this.addEventListener('input',e=>{if(e.target.name==='quantity') this.update();});
      this.addEventListener('click',e=>{
        const track=this.querySelector('.ph-gallery__track'),motion=matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth';
        const step=e.target.closest('[data-gallery-step]');if(step)track.scrollBy({left:track.clientWidth*Number(step.dataset.galleryStep),behavior:motion});
        const thumb=e.target.closest('[data-gallery-index]');if(thumb)track.scrollTo({left:track.clientWidth*Number(thumb.dataset.galleryIndex),behavior:motion});
        const qty=e.target.closest('[data-qty]');if(qty){const field=this.form.elements.quantity;field.value=Math.max(1,Math.min(10,(Number(field.value)||1)+Number(qty.dataset.qty)));this.update();}
      });
      this.form.addEventListener('submit',async e=>{
        e.preventDefault();if(!this.form.reportValidity())return;if(this.saleWasActive&&saleEnded()){location.reload();return;}const state=this.state();if(!state.available||window.PawHabit.busy)return;
        const button=this.querySelector('[data-add]'),error=this.querySelector('[data-error]');button.disabled=true;error.hidden=true;this.querySelector('[data-add-label]').textContent=this.labels.adding;
        try { const done=await updateCart(state.items,state.offer==='single'?'':this.dataset.code,this,this.dataset.personalized==='true'?new FormData(this.form):undefined); if(done)this.querySelector('[data-add-label]').textContent=this.labels.added; }
        catch(err){error.hidden=false;error.textContent=err.message||this.labels.error;}
        finally {this.update();}
      });this.update();
      const track=this.querySelector('.ph-gallery__track'),thumbs=[...this.querySelectorAll('[data-gallery-index]')];
      const gallerySync=()=>{const index=Math.min(thumbs.length-1,Math.max(0,Math.round(track.scrollLeft/track.clientWidth)||0));thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));this.querySelector('[data-gallery-count]').textContent=(index+1)+' / '+thumbs.length;this.querySelector('[data-gallery-step="-1"]').disabled=index===0;this.querySelector('[data-gallery-step="1"]').disabled=index>=thumbs.length-1;};
      track.addEventListener('scroll',gallerySync,{passive:true});this.galleryObserver=new ResizeObserver(gallerySync);this.galleryObserver.observe(track);gallerySync();this.syncVariantImage(this.state().v);
    }
    previewPhoto(input){
      if(this.photoUrl)URL.revokeObjectURL(this.photoUrl);
      const file=input.files[0],preview=this.querySelector('[data-photo-preview]');input.setCustomValidity('');preview.hidden=true;
      if(!file)return;
      if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>10*1024*1024){input.setCustomValidity(input.dataset.errorSize);input.reportValidity();return;}
      this.photoUrl=URL.createObjectURL(file);preview.querySelector('img').src=this.photoUrl;preview.querySelector('[data-photo-name]').textContent=file.name;preview.hidden=false;
    }
    syncVariantImage(variant){
      const slides=[...this.querySelectorAll('.ph-gallery__slide')],index=slides.findIndex(x=>x.dataset.imageId===String(variant.imageId));
      const track=this.querySelector('.ph-gallery__track');
      if(index>=0){track.scrollTo({left:track.clientWidth*index,behavior:motionPreference.matches?'instant':'smooth'});}
      else if(variant.imageUrl&&slides[0]?.dataset.imageId){
        const img=slides[0].querySelector('img'),thumb=this.querySelector('[data-gallery-index="0"] img');
        img.src=variant.imageUrl;img.removeAttribute('srcset');img.alt=variant.options.join(' / ');slides[0].dataset.imageId=String(variant.imageId);
        if(thumb){thumb.src=variant.imageUrl;thumb.removeAttribute('srcset');}
        track.scrollTo({left:0,behavior:motionPreference.matches?'instant':'smooth'});
      }
    }
    disconnectedCallback(){this.galleryObserver?.disconnect();if(this.photoUrl)URL.revokeObjectURL(this.photoUrl);delete this.dataset.ready;}
    state(){
      const v=this.variants.find(v=>String(v.id)===String(this.form.elements.id.value))||this.variants[0];
      const qty=Math.max(1,Math.min(10,Number(this.form.elements.quantity.value)||1));
      const offer=saleEnded()?'single':(this.querySelector('[name="paw_offer"]:checked')?.value||'single');
      const items=[{id:v.id,quantity:offer==='duo'?2:qty}];if(offer==='pair') {items[0].quantity=1;items.push({id:Number(this.dataset.pair),quantity:1});}
      const original=offer==='pair'?v.price+Number(this.dataset.pairPrice):v.price*items[0].quantity;
      const total=original-(offer==='single'?0:Number(this.dataset.saving));
      const available=v.available&&(offer!=='pair'||this.dataset.pairAvailable==='true')&&(v.policy!=='deny'||!v.tracked||v.inventory>=items[0].quantity);
      const reference=offer==='pair'?Math.max(v.compare,v.price)+Number(this.dataset.pairReference):Math.max(v.compare,v.price)*items[0].quantity;
      return {v,qty,offer,items,original,total,available,reference};
    }
    update(){
      const s=this.state(),format=c=>money(c,this.dataset.currency);
      this.syncOptionControls(s.v);
      document.dispatchEvent(new CustomEvent('paw:variant',{detail:s.v}));
      const displayPrice=s.offer==='single'?s.v.price:s.total,referencePrice=s.offer==='single'?Math.max(s.v.compare,s.v.price):s.reference,onSale=referencePrice>displayPrice;
      this.querySelector('[data-price]').textContent=format(displayPrice);
      const compare=this.querySelector('[data-compare]'),save=this.querySelector('[data-saving-label]');compare.hidden=save.hidden=!onSale;compare.textContent=format(referencePrice);save.textContent=this.labels.save+' '+format(referencePrice-displayPrice);
      const deal=this.querySelector('[data-deal]');if(deal){deal.dataset.onSale=String(onSale);this.querySelector('[data-sale-heading]').hidden=!onSale||saleEnded();const note=this.querySelector('[data-sale-note]');note.hidden=!onSale;note.textContent=s.offer==='single'?this.labels.singleSaleNote:this.labels.pairSaleNote.replace('[amount]',format(Number(this.dataset.saving)));}
      this.querySelector('[data-order-total]').textContent=format(s.total);
      this.querySelector('[data-add]').disabled=!s.available;this.querySelector('[data-add-label]').textContent=s.available?this.labels.add:this.labels.unavailable;
      const express=this.querySelector('[data-express]');if(express)express.hidden=s.offer!=='single'||!s.available;
      this.querySelector('.ph-qty-row').hidden=s.offer!=='single';
      const stock=this.querySelector('[data-stock]');stock.hidden=!(s.v.tracked&&s.v.policy==='deny'&&s.v.inventory>0&&s.v.inventory<=Number(this.dataset.lowStock));stock.textContent=this.labels.lowStock.replace('[count]',String(s.v.inventory));
      const url=new URL(location.href);url.searchParams.set('variant',String(s.v.id));history.replaceState(null,'',url);
    }
    syncOptionControls(variant){
      this.querySelectorAll('[data-option-group]').forEach(group=>{
        const position=Number(group.dataset.optionGroup);group.querySelector('[data-option-selected]').textContent=variant.options[position];
        group.querySelectorAll('[data-product-option]').forEach(input=>{
          input.checked=variant.options[position]===input.value;
          const available=this.variants.some(v=>v.available&&v.options.every((value,i)=>i===position?value===input.value:value===variant.options[i]));
          input.closest('.ph-variant-choice').dataset.unavailable=String(!available);
        });
      });
      const status=this.querySelector('[data-variant-status]');if(status)status.textContent=variant.available?'':this.labels.unavailable;
      const colors=[['light purple','#c3afd2'],['dark green','#3b5244'],['army green','#707654'],['azure blue','#8baec1'],['navy blue','#313f55'],['sky blue','#b0cfde'],['peach pink','#dda99c'],['wine red','#70343e'],['dark gray','#525454'],['light gray','#bcbdb9'],['light brown','#b79577'],['skin powder','#ddc1b7'],['coffee','#795b47'],['khaki','#b5a080'],['taupe','#a69582'],['beige','#ded1b8'],['gray','#999c98'],['grey','#999c98'],['blue','#7396b5'],['green','#819477'],['purple','#a18daf'],['pink','#deb4bb'],['red','#a94c4d'],['yellow','#d8bc6f'],['black','#343735'],['white','#ede9df']];
      this.querySelectorAll('[data-swatch]').forEach(swatch=>{if(swatch.querySelector('img'))return;const key=swatch.dataset.swatch.toLowerCase();swatch.style.setProperty('--swatch-color',colors.find(([name])=>key.includes(name))?.[1]||'#d5c7b6');});
      const parts=this.sockParts(variant.options[1]);
      if(parts)this.querySelectorAll('[data-composite-axis]').forEach(input=>{input.checked=input.value===parts[input.dataset.compositeAxis==='size'?1:2];});
    }
    sockParts(value){
      const old=value?.match(/^(XS|S|M|L|XL) (OPP|GiftBag) 4pcs$/);if(old)return old;
      const clean=value?.match(/^(XS|S|M|L|XL) · (Standard pack|Gift bag) · 4 socks$/);return clean?[clean[0],clean[1],clean[2]==='Standard pack'?'OPP':'GiftBag']:null;
    }
    setupCompositeOptions(){
      if(this.querySelector('.ph-variant-composite'))return;
      const group=this.querySelector('[data-option-group="1"]');
      if(!group||!this.variants.every(v=>this.sockParts(v.options[1])))return;
      const container=document.createElement('div');container.className='ph-variant-composite';
      [['size','Size',[['XS','XS'],['S','S'],['M','M'],['L','L'],['XL','XL']]],['pack','Packaging',[['OPP','Standard pack'],['GiftBag','Gift bag']]]].forEach(([axis,title,values])=>{
        const fieldset=document.createElement('fieldset');fieldset.className='ph-variant-group';const legend=document.createElement('legend');legend.textContent=title;fieldset.append(legend);const choices=document.createElement('div');choices.className='ph-variant-choices';
        values.forEach(([value,label])=>{const el=document.createElement('label');el.className='ph-variant-choice';const input=document.createElement('input');input.type='radio';input.name='paw_'+axis;input.value=value;input.dataset.compositeAxis=axis;const surface=document.createElement('span');surface.className='ph-variant-choice__surface';surface.textContent=label;el.append(input,surface);choices.append(el);});fieldset.append(choices);container.append(fieldset);
      });group.before(container);group.hidden=true;
    }
  }

  class PawPair extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.select=this.querySelector('[name="companion"]');this.primary={id:Number(this.dataset.primary),price:Number(this.dataset.primaryPrice),compare:Number(this.dataset.primaryCompare),available:true};
      this.sync=()=>{const option=this.select.selectedOptions[0];if(!option)return;const image=this.querySelectorAll('.ph-pair-item img')[1];if(image&&option.dataset.image){image.src=option.dataset.image;image.removeAttribute('srcset');image.alt=option.textContent;}const p=Number(option.dataset.price),sum=this.primary.price+p,percent=Number(this.dataset.percent)/100,saving=Math.floor(this.primary.price*percent)+Math.floor(p*percent),format=c=>money(c,this.dataset.currency);this.querySelector('[data-primary-price]').textContent=format(this.primary.price);this.querySelector('[data-companion-price]').textContent=format(p);this.querySelector('[data-pair-original]').textContent=format(sum);this.querySelector('[data-pair-saving]').textContent='−'+format(saving);this.querySelector('[data-pair-total]').textContent=format(sum-saving);const original=Math.max(this.primary.price,this.primary.compare||0)+Math.max(p,Number(option.dataset.compare)||0);this.querySelector('[data-total-saving]').textContent=format(original-sum+saving);this.querySelector('[data-total-saving-row]').hidden=original<=sum;const button=this.querySelector('button[type="submit"]');if(button)button.disabled=!this.primary.available||option.disabled;};
      this.onVariant=e=>{this.primary=e.detail;this.querySelector('[data-primary-option]').textContent=this.primary.options.join(' / ');const img=this.querySelector('.ph-pair-item img');if(this.primary.imageUrl){img.src=this.primary.imageUrl;img.removeAttribute('srcset');img.alt=this.primary.options.join(' / ');}this.sync();};
      document.addEventListener('paw:variant',this.onVariant);this.select.addEventListener('change',()=>{const image=this.querySelectorAll('.ph-pair-item img')[1];image.src=this.select.selectedOptions[0].dataset.image;image.removeAttribute('srcset');this.sync();});
      const product=document.querySelector('paw-product');if(product?.state)this.onVariant({detail:product.state().v});else this.sync();
      this.querySelector('form').addEventListener('submit',async e=>{e.preventDefault();if(saleEnded()){location.reload();return;}if(window.PawHabit.busy)return;const button=this.querySelector('button[type="submit"]');if(!button)return;button.disabled=true;button.textContent=button.dataset.addingLabel;const error=this.querySelector('[data-error]');error.hidden=true;try{await updateCart([{id:this.primary.id,quantity:1},{id:Number(this.select.value),quantity:1}],'',this);}catch(err){error.hidden=false;error.textContent=err.message;}finally{button.textContent=button.dataset.addLabel;this.sync();}});
    }
    disconnectedCallback(){document.removeEventListener('paw:variant',this.onVariant);}
  }
  if(!customElements.get('paw-pair'))customElements.define('paw-pair',PawPair);

  class PawReviews extends HTMLElement {
    connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const track=this.querySelector('.ph-review-track'),filter=this.querySelector('[data-review-filter]');
      this.addEventListener('click',e=>{const b=e.target.closest('[data-review-step]');if(b)track.scrollBy({left:track.clientWidth*Number(b.dataset.reviewStep)*0.9,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});
      const sync=()=>{this.querySelectorAll('.ph-review-card').forEach(card=>card.hidden=filter.value!=='all'&&card.dataset.rating!==filter.value);const total=this.querySelectorAll('.ph-review-card:not([hidden])').length;this.querySelector('[data-review-status]').textContent=total+' '+this.dataset.countLabel;};
      filter.addEventListener('change',()=>{sync();track.scrollLeft=0;nav();});sync();
      const nav=()=>{this.querySelector('[data-review-step="-1"]').disabled=track.scrollLeft<2;this.querySelector('[data-review-step="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};track.addEventListener('scroll',nav,{passive:true});this.observer=new ResizeObserver(nav);this.observer.observe(track);nav();
    }
    disconnectedCallback(){this.observer?.disconnect();}
  }
  if(!customElements.get('paw-product'))customElements.define('paw-product',PawProduct);
  if(!customElements.get('paw-reviews'))customElements.define('paw-reviews',PawReviews);
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-paw-addon],[data-paw-discount]');if(!form)return;e.preventDefault();if(window.PawHabit.busy)return;
    const button=form.querySelector('button'),error=form.querySelector('[data-error]');button.disabled=true;if(error)error.hidden=true;
    try{await updateCart(form.dataset.pawAddon?[{id:Number(form.elements.id?.value||form.dataset.pawAddon),quantity:1}]:[],form.dataset.pawDiscount||'',form);}
    catch(err){if(error){error.hidden=false;error.textContent=err.message;}}
    finally{button.disabled=false;}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-product-focused"] && !Shopify.designMode) return;
  try {
    
class PawBuyBar extends HTMLElement {
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  this.owner=this.closest('paw-product');this.original=this.owner.querySelector('[data-add]');this.button=this.querySelector('button');
  this.update=()=>{
   const selected=[...this.owner.querySelectorAll('[data-product-option]:checked')].map(x=>x.value).join(' / ');
   const quantity=Number(this.owner.querySelector('[name=quantity]').value)||1;
   this.querySelector('[data-dock-option]').textContent=(quantity>1?quantity+' × ':'')+selected;
   this.querySelector('[data-dock-price]').textContent=this.owner.querySelector('[data-order-total]').textContent;
   this.querySelector('[data-dock-label]').textContent=this.owner.querySelector('[data-add-label]').textContent;
   this.button.disabled=this.original.disabled;
  };
  this.onClick=()=>{this.original.click();if(!this.owner.querySelector('form').checkValidity()||this.owner.querySelector('[data-error]:not([hidden])'))this.original.scrollIntoView({block:'center',behavior:'smooth'});};
  this.button.addEventListener('click',this.onClick);
  this.observer=new MutationObserver(this.update);this.observer.observe(this.original,{subtree:true,characterData:true,childList:true,attributes:true,attributeFilter:['disabled']});
  this.owner.addEventListener('change',this.update);
  this.visibility=new IntersectionObserver(entries=>{this.hidden=entries[0].isIntersecting;},{threshold:.5});this.visibility.observe(this.original);
  this.update();
 }
 disconnectedCallback(){this.observer?.disconnect();this.visibility?.disconnect();this.button?.removeEventListener('click',this.onClick);this.owner?.removeEventListener('change',this.update);this.initialized=false;}
}
if(!customElements.get('paw-buy-bar'))customElements.define('paw-buy-bar',PawBuyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-product-seasonal"] && !Shopify.designMode) return;
  try {
    
class PawSeasonalBuyBar extends HTMLElement {
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  this.owner=this.closest('paw-product');this.original=this.owner.querySelector('[data-add]');this.button=this.querySelector('button');
  this.update=()=>{
   const selected=[...this.owner.querySelectorAll('[data-product-option]:checked')].map(x=>x.value).join(' / ');
   const quantity=Number(this.owner.querySelector('[name=quantity]').value)||1;
   this.querySelector('[data-dock-option]').textContent=(quantity>1?quantity+' × ':'')+selected;
   this.querySelector('[data-dock-price]').textContent=this.owner.querySelector('[data-order-total]').textContent;
   this.querySelector('[data-dock-label]').textContent=this.owner.querySelector('[data-add-label]').textContent;
   this.button.disabled=this.original.disabled;
  };
  this.onClick=()=>{this.original.click();if(!this.owner.querySelector('form').checkValidity()||this.owner.querySelector('[data-error]:not([hidden])'))this.original.scrollIntoView({block:'center',behavior:'smooth'});};
  this.button.addEventListener('click',this.onClick);
  this.observer=new MutationObserver(this.update);this.observer.observe(this.original,{subtree:true,characterData:true,childList:true,attributes:true,attributeFilter:['disabled']});
  this.owner.addEventListener('change',this.update);
  this.visibility=new IntersectionObserver(entries=>{this.hidden=entries[0].isIntersecting;},{threshold:.5});this.visibility.observe(this.original);
  this.update();
 }
 disconnectedCallback(){this.observer?.disconnect();this.visibility?.disconnect();this.button?.removeEventListener('click',this.onClick);this.owner?.removeEventListener('change',this.update);this.initialized=false;}
}
if(!customElements.get('paw-seasonal-buy-bar'))customElements.define('paw-seasonal-buy-bar',PawSeasonalBuyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-size-guide"] && !Shopify.designMode) return;
  try {
    
class PawSizeGuide extends HTMLElement {
 connectedCallback(){
  if(this.bound)return;this.bound=true;
  this.rows=[...this.querySelectorAll('[data-fit-row]')];
  this.select=row=>{this.rows.forEach(r=>{r.classList.toggle('is-selected',r===row);r.querySelector('button')?.setAttribute('aria-pressed',String(r===row));});};
  this.querySelectorAll('[data-fit-size]').forEach(b=>b.addEventListener('click',()=>this.select(b.closest('tr'))));
  const input=this.querySelector('[data-fit-input]'),result=this.querySelector('[data-fit-result]');
  this.querySelector('[data-fit-check]')?.addEventListener('click',()=>{
   const value=Number(input.value);
   if(!Number.isFinite(value)||value<=0){result.textContent=result.dataset.empty;input.focus();return;}
   const match=this.rows.find(r=>Number(r.children[1]?.textContent)>=value);
   this.select(match);
   result.textContent=match?result.dataset.result.replace('[size]',match.querySelector('button').textContent):result.dataset.large;
  });
 }
}
if(!customElements.get('paw-size-guide'))customElements.define('paw-size-guide',PawSizeGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-welcome-gift"]) return;
  try {
    
(() => {
  let queued = false;
  function updateGiftClearance() {
    queued = false;
    const host = document.querySelector('paw-welcome-gift');
    if (!host) return;
    let clearance = 96;
    if (innerWidth <= 749) {
      document.querySelectorAll('.ph-focus-dock:not([hidden])').forEach(dock => {
        const rect = dock.getBoundingClientRect();
        if (rect.width && rect.height && rect.top < innerHeight) clearance = Math.max(clearance, innerHeight - rect.top + 12);
      });
    }
    host.style.setProperty('--paw-gift-clearance', clearance + 'px');
  }
  function scheduleGiftClearance() { if (!queued) { queued = true; requestAnimationFrame(updateGiftClearance); } }
  function startGiftClearance() {
    if (!document.body || window.pawGiftClearanceReady) return;
    window.pawGiftClearanceReady = true;
    new MutationObserver(scheduleGiftClearance).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['hidden']});
    addEventListener('resize', scheduleGiftClearance);
    document.addEventListener('shopify:section:load', scheduleGiftClearance);
    scheduleGiftClearance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startGiftClearance, {once:true}); else startGiftClearance();
})();

  } catch(e) { console.error(e); }
})();
})();
